
import { useRef } from "react";
import { FormField, FormItem, FormLabel, FormControl } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "../schema/rustCourseFormSchema";

interface HoneyPotFieldProps {
  form: UseFormReturn<FormValues>;
}

export const HoneyPotField = ({ form }: HoneyPotFieldProps) => {
  const honeyRef = useRef<HTMLInputElement>(null);
  
  return (
    <div className="hidden" aria-hidden="true">
      <FormField
        control={form.control}
        name="honey"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Leave this empty</FormLabel>
            <FormControl>
              <Input ref={honeyRef} tabIndex={-1} autoComplete="off" {...field} />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
};
